(function () {
    function getReviewItems(sectionElement) {
        return Array.prototype.slice.call(
            sectionElement.querySelectorAll('[data-home-review-item]')
        );
    }

    function splitQuoteWords(sectionElement) {
        var quoteElements = sectionElement.querySelectorAll('.filadelfia-home-reviews__quote');

        quoteElements.forEach(function (quoteElement) {
            if (quoteElement.dataset.wordsSplit === 'true') {
                return;
            }

            var textNodes = [];
            var walker = document.createTreeWalker(quoteElement, NodeFilter.SHOW_TEXT, {
                acceptNode: function (node) {
                    return node.nodeValue && node.nodeValue.trim()
                        ? NodeFilter.FILTER_ACCEPT
                        : NodeFilter.FILTER_REJECT;
                }
            });

            while (walker.nextNode()) {
                textNodes.push(walker.currentNode);
            }

            textNodes.forEach(function (textNode) {
                var fragment = document.createDocumentFragment();
                var parts = textNode.nodeValue.split(/(\s+)/);

                parts.forEach(function (part) {
                    if (!part) {
                        return;
                    }

                    if (/^\s+$/.test(part)) {
                        fragment.appendChild(document.createTextNode(part));
                        return;
                    }

                    var wordElement = document.createElement('span');
                    wordElement.className = 'filadelfia-home-reviews__quote-word';
                    wordElement.textContent = part;
                    fragment.appendChild(wordElement);
                });

                textNode.parentNode.replaceChild(fragment, textNode);
            });

            quoteElement.dataset.wordsSplit = 'true';
        });
    }

    function animateQuoteWords(itemElement, isActive) {
        if (!window.gsap) {
            return;
        }

        var words = itemElement.querySelectorAll('.filadelfia-home-reviews__quote-word');

        if (!words.length) {
            return;
        }

        window.gsap.killTweensOf(words);

        if (isActive) {
            if (itemElement.dataset.wordsRevealed === 'true') {
                window.gsap.set(words, {
                    color: '#F3E9D9',
                    opacity: 1
                });
                return;
            }

            if (itemElement.dataset.wordsAnimating === 'true') {
                return;
            }

            itemElement.dataset.wordsAnimating = 'true';

            window.gsap.fromTo(words, {
                color: 'rgba(243, 233, 217, 0.44)',
                opacity: 0.58
            }, {
                color: '#F3E9D9',
                opacity: 1,
                duration: 0.24,
                stagger: 0.055,
                ease: 'power1.out',
                overwrite: true,
                onComplete: function () {
                    itemElement.dataset.wordsAnimating = 'false';
                    itemElement.dataset.wordsRevealed = 'true';
                }
            });
            return;
        }

        if (itemElement.dataset.wordsRevealed !== 'true') {
            window.gsap.to(words, {
                color: 'rgba(243, 233, 217, 0.44)',
                opacity: 0.58,
                duration: 0.18,
                ease: 'power1.out',
                overwrite: true
            });
        }
    }

    function setActiveReview(sectionElement, index) {
        var reviewItems = getReviewItems(sectionElement);
        var previousIndex = sectionElement._filadelfiaActiveReviewIndex;
        var activeChanged = previousIndex !== index;

        sectionElement._filadelfiaActiveReviewIndex = index;

        reviewItems.forEach(function (itemElement, itemIndex) {
            var isActive = itemIndex === index;
            itemElement.classList.toggle('is-active', isActive);

            if (!isActive || activeChanged || itemElement.dataset.wordsRevealed !== 'true') {
                animateQuoteWords(itemElement, isActive);
            }

            if (window.gsap) {
                window.gsap.to(itemElement, {
                    opacity: isActive ? 1 : (window.innerWidth < 990 ? 0.62 : 0.46),
                    y: isActive ? -2 : 0,
                    scale: isActive ? 1.012 : 0.992,
                    duration: 0.34,
                    ease: 'power2.out',
                    overwrite: true
                });
            }
        });
    }

    function clearTriggers(sectionElement) {
        if (!sectionElement._filadelfiaReviewTriggers) {
            return;
        }

        sectionElement._filadelfiaReviewTriggers.forEach(function (triggerInstance) {
            triggerInstance.kill();
        });

        sectionElement._filadelfiaReviewTriggers = [];
    }

    function getNearestReviewIndex(sectionElement) {
        var reviewItems = getReviewItems(sectionElement);
        var viewportFocus = window.innerHeight * (window.innerWidth < 990 ? 0.56 : 0.5);
        var nearestIndex = 0;
        var nearestDistance = Infinity;

        reviewItems.forEach(function (itemElement, index) {
            var rect = itemElement.getBoundingClientRect();
            var itemCenter = rect.top + rect.height * 0.5;
            var distance = Math.abs(itemCenter - viewportFocus);

            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
            }
        });

        return nearestIndex;
    }

    function updateActiveFromViewport(sectionElement) {
        var sectionRect = sectionElement.getBoundingClientRect();

        if (sectionRect.bottom < 0 || sectionRect.top > window.innerHeight) {
            return;
        }

        setActiveReview(sectionElement, getNearestReviewIndex(sectionElement));
    }

    function bindScrollFallback(sectionElement) {
        if (sectionElement._filadelfiaReviewsScrollBound) {
            return;
        }

        sectionElement._filadelfiaReviewsScrollBound = true;

        var ticking = false;
        var handleScroll = function () {
            if (ticking) {
                return;
            }

            ticking = true;
            window.requestAnimationFrame(function () {
                ticking = false;
                updateActiveFromViewport(sectionElement);
            });
        };

        sectionElement._filadelfiaReviewsScrollHandler = handleScroll;
        window.addEventListener('scroll', handleScroll, { passive: true });
    }

    function bindReviewScroll(sectionElement) {
        if (!window.gsap || !window.ScrollTrigger) {
            return false;
        }

        window.gsap.registerPlugin(window.ScrollTrigger);
        clearTriggers(sectionElement);

        var reviewItems = getReviewItems(sectionElement);

        if (!reviewItems.length) {
            return;
        }

        setActiveReview(sectionElement, 0);
        bindScrollFallback(sectionElement);

        sectionElement._filadelfiaReviewTriggers = [
            window.ScrollTrigger.create({
                trigger: sectionElement,
                start: 'top bottom',
                end: 'bottom top',
                onEnter: function () {
                    updateActiveFromViewport(sectionElement);
                },
                onEnterBack: function () {
                    updateActiveFromViewport(sectionElement);
                },
                onUpdate: function () {
                    updateActiveFromViewport(sectionElement);
                }
            })
        ];

        window.ScrollTrigger.refresh();
        updateActiveFromViewport(sectionElement);
        return true;
    }

    function initHomeReviews(sectionElement) {
        if (!sectionElement) {
            return;
        }

        if (!window.gsap || !window.ScrollTrigger) {
            return;
        }

        if (sectionElement.dataset.initialized === 'true') {
            splitQuoteWords(sectionElement);
            bindReviewScroll(sectionElement);
            return;
        }

        sectionElement.dataset.initialized = 'true';
        sectionElement._filadelfiaReviewTriggers = [];
        splitQuoteWords(sectionElement);

        bindReviewScroll(sectionElement);

        if (!sectionElement._filadelfiaHomeReviewsResizeBound) {
            sectionElement._filadelfiaHomeReviewsResizeBound = true;
            window.addEventListener('resize', function () {
                bindReviewScroll(sectionElement);
            });
        }
    }

    window.filadelfiaHomeReviews = {
        init: initHomeReviews
    };
})();
